// Section for import npm components -----------------------------------------------------------------------------------
import React from 'react';
import Quill from 'quill';
import 'quill/dist/quill.snow.css';
import { format } from 'date-fns';

// Material UI ( mui ) components
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';

// Section for import custom components --------------------------------------------------------------------------------

// Section for render component ----------------------------------------------------------------------------------------

// Section for type definition -----------------------------------------------------------------------------------------
import MansionAroundExtendPropsData from '@/types/components/MansionDetail/MansionAroundExtendPropsData';

type MansionAroundExtendProps = {
  mansionAroundExtend: MansionAroundExtendPropsData;
};

// QuillエディタのLinkフォーマットを拡張
const Link = Quill.import('formats/link');

class CustomLink extends (Link as any) {
  static create(value: string) {
    const node = super.create(value);
    node.setAttribute('rel', 'noopener noreferrer nofollow');
    node.setAttribute('target', '_blank');
    return node;
  }
}

// カスタムリンクフォーマットをQuillに登録
Quill.register(CustomLink, true);

const renderQuillContent = (content: string) => {
  const quillContainer = document.createElement('div');
  const quill = new Quill(quillContainer, {
    theme: 'snow',
    readOnly: true,
    modules: {
      toolbar: false,
    },
  });

  // Delta形式のコンテンツを設定
  const parsedContent = JSON.parse(content);
  quill.setContents(parsedContent);

  // getSemanticHTMLメソッドを使用してHTMLを取得
  const semanticHTML = quill.root.innerHTML;

  return <div dangerouslySetInnerHTML={{ __html: semanticHTML }} />;
};

export default function MansionAroundData(props: MansionAroundExtendProps) {
  const { mansionAroundExtend } = props;
  return (
    <Box>
      <Container className="md:max-w-7xl md:w-full mx-auto max-md:mx-0 mb-16 max-md:mb-12 md:px-24 max-md:px-5">
        <Typography
          component="h2"
          variant="h2"
          className="border-solid border-l-2 border-rf-black relative mb-6 pl-4 text-lg font-bold before:absolute before:top-1 before:left-[-16px]"
        >
          {mansionAroundExtend.aroundTitle}
        </Typography>
        <Box className="md:max-w-[780px] max-md:w-full md:mx-auto max-md:mx-0 ql-snow">
          <Box
            id="wysiwyg-content-around"
            className="mb-7 max-md:mb-5 md:px-6 max-md:px-0 pt-2 ql-editor"
          >
            {renderQuillContent(mansionAroundExtend.aroundDescription)}
          </Box>
          <Box className="mt-4 md:pr-6 text-right">
            <Typography className="text-xs font-bold"> {mansionAroundExtend.aroundTitle}</Typography>
            <Typography className="text-xs">
              更新日時：{format(new Date(mansionAroundExtend.aroundDate), 'yyyy/MM/dd')}
            </Typography>
          </Box>
        </Box>
      </Container>
    </Box>
  );
}
